import styled from 'styled-components';
import { palette } from 'styled-theme';
import {
  transition,
  borderRadius,
  boxShadow,
} from '@iso/lib/helpers/style_utils';
import WithDirection from '@iso/lib/helpers/rtl';

const TopbarWrapper = styled.div`
  .isomorphicTopbar {
    width: calc(100% - 240px);

    display: flex;
    justify-content: space-between;
    background-color: #2A4A3A;
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    padding: ${props =>
      props['data-rtl'] === 'rtl' ? '0 15px 0 31px' : '0 31px 0 15px'};
    ${props =>
        props['data-rtl'] === 'rtl' ? 'margin-right: : 240px' : 'margin-left : 240px'};  
    z-index: 1000;
    ${transition()};

    @media only screen and (max-width: 767px) {
      width: 100%;
      padding: ${props =>
        props['data-rtl'] === 'rtl'
          ? '0px 20px 0px 15px !important'
          : '0px 15px 0px 20px !important'};
    }

    &.collapsed {
      width: calc(100% - 80px);
      padding: ${props =>
        props['data-rtl'] === 'rtl' ? '0 29px 0 31px' : '0 31px 0 55px'};
      ${props =>
        props['data-rtl'] === 'rtl' ? 'margin-right: : 80px' : 'margin-left : 80px'};
      @media only screen and (max-width: 767px) {
        width: 100%;
        padding: ${props =>
          props['data-rtl'] === 'rtl'
            ? '0px 15px !important'
            : '0px 15px !important'};
        ${props =>
        props['data-rtl'] === 'rtl' ? 'margin-right: : 0px' : 'margin-left : 0px'};      
      }
      
    }

    .isoLeft {
      display: flex;
      align-items: center;
      width: 60%;

      @media only screen and (max-width: 767px) {
        width: 100%;
        margin: ${props =>
          props['data-rtl'] === 'rtl' ? '0 0 0 20px' : '0 20px 0 0'};        
      }

      .triggerBtn {
        margin-right : 10px;
        width: 24px;
        height: 100%;
        display: -webkit-inline-flex;
        display: -ms-inline-flex;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        border: 0;
        outline: 0;
        position: relative;
        cursor: pointer;

        &:before {
          content: '\f20e';
          font-family: 'Ionicons';
          font-size: 26px;
          color: inherit;
          line-height: 0;
          position: absolute;
        }
      }
    }
    .head-bar-notificication{
      position: relative;
      .count-notification{
        position: absolute;
        top: -9px;
        font-size: 10px;
        color: #ffffff;
        background-color: #0B2A1B;
        padding: 2px 5px;
        border-radius: 50px;
        right: -6px;
      }
    }
    .site-form-item-icon {
      height: 19px;
      width: 19px;
      color: #cfdcd4;
      font-size: 19px;
    }

    /* Notification / action icons and user name sit on the green bar now. */
    .isoRight,
    .isoRight a,
    .isoRight span,
    .isoRight .anticon,
    .isoRight svg {
      color: #ffffff;
    }

    /* Some topbar icons (e.g. FormIcon) hard-code fill="black" on their SVG
       paths, which \`color\` can't reach — force them white on the green bar. */
    .isoRight svg path[fill="black"],
    .isoRight svg path[fill="#000"],
    .isoRight svg path[fill="#000000"] {
      fill: #ffffff;
    }

    .search-bar {
      font-family: DM Sans;
font-size: 14px;
font-weight: 500;
line-height: 24px;


      background: rgba(255, 255, 255, 0.14) !important;
      border-radius: 8px !important;
      border: none;
      flex-direction: row-reverse;
      max-width: 330px;
    }

    .search-bar .ant-input::placeholder {
      color: #cfdcd4;
    }

    .search-bar .ant-input {
      background: none!important;
      border: none!important;
      color: #ffffff;
      font-family: DM Sans;
      font-style: normal;
      font-weight: 500;
      letter-spacing: -0.20000000298023224px;
text-align: left;
      font-size: 14px;
      line-height: 24px;
    }
    .isoRight {
      display: flex;
      align-items: center;

      li {
        margin-left: ${props => (props['data-rtl'] === 'rtl' ? '20px' : '0')};
        margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '20px')};
        cursor: pointer;
        line-height: normal;
        position: relative;
        display: inline-block;

        @media only screen and (max-width: 360px) {
          margin-left: ${props => (props['data-rtl'] === 'rtl' ? '25px' : '0')};
          margin-right: ${props =>
            props['data-rtl'] === 'rtl' ? '0' : '25px'};
        }

        &:last-child {
          margin: 0;
        }

        i {
          font-size: 24px;
          color: ${palette('text', 0)};
          line-height: 1;
        }

        .isoIconWrapper {
          position: relative;
          line-height: normal;

          span {
            font-size: 12px;
            color: #fff;
            background-color: ${palette('secondary', 1)};
            width: 20px;
            height: 20px;
            display: -webkit-inline-flex;
            display: -ms-inline-flex;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            line-height: 20px;
            position: absolute;
            top: -8px;
            left: ${props =>
              props['data-rtl'] === 'rtl' ? 'inherit' : '10px'};
            right: ${props =>
              props['data-rtl'] === 'rtl' ? '10px' : 'inherit'};
            ${borderRadius('50%')};
          }
        }

        &.isoMail {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 0)};
            }
          }
        }

        &.isoNotify {
          .isoIconWrapper {
            span {
              background-color: ${palette('primary', 2)};
            }
          }
        }

        &.isoMsg {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 1)};
            }
          }
        }

        &.isoCart {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 2)};
            }
          }
        }

        &.isoUser {
          /* Avatar sits to the LEFT of the name (Figma) — small gap to the name. */
          margin-right: 10px;

          .isoImgWrapper {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            background-color: ${palette('grayscale', 9)};
            ${borderRadius('50%')};

            img {
              height: 100%;
              object-fit: cover;
            }

            /* Fallback when the user has no profile picture: green circle with
               their first initial. */
            &.isoImgWrapper-initial {
              background-color: #3a5647;
              border: 1px solid rgba(255, 255, 255, 0.2);
            }

            .topbar-avatar-initial {
              color: #ffffff;
              font-size: 16px;
              font-weight: 600;
              line-height: 1;
              text-transform: uppercase;
            }

            .userActivity {
              width: 10px;
              height: 10px;
              display: block;
              background-color: ${palette('color', 3)};
              position: absolute;
              bottom: 0;
              right: 3px;
              border: 1px solid #ffffff;
              ${borderRadius('50%')};
            }
          }
        }
      }

      .isoUserName {
        margin-right: 10px;
      }
    }
  }

  .isoUserDropdown {
    .ant-popover-inner {
      .ant-popover-inner-content {
        .isoUserDropdownContent {
          padding: 7px 0;
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 0;
          right: 0;
          background-color: #ffffff;
          width: 220px;
          min-width: 160px;
          flex-shrink: 0;
          .isoBorderRadius(5px);
          ${borderRadius('5px')};
          ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
          ${transition()};

          .isoDropdownLink {
            font-size: 13px;
            color: ${palette('text', 1)};
            line-height: 1.1;
            padding: 7px 15px;
            background-color: transparent;
            text-decoration: none;
            display: flex;
            justify-content: flex-start;
            ${transition()};

            &:hover {
              background-color: ${palette('secondary', 6)};
            }
          }
        }
      }
    }
  }

  // Dropdown
  .ant-popover {
    .ant-popover-inner {
      .ant-popover-inner-content {
        .isoDropdownContent {
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 0;
          right: 0;
          background-color: #ffffff;
          width: 360px;
          min-width: 160px;
          flex-shrink: 0;
          ${borderRadius('5px')};
          ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
          ${transition()};

          @media only screen and (max-width: 767px) {
            width: 310px;
          }

          .isoDropdownHeader {
            border-bottom: 1px solid #f1f1f1;
            margin-bottom: 0px;
            padding: 15px 30px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            h3 {
              font-size: 14px;
              font-weight: 500;
              color: ${palette('text', 0)};
              text-align: center;
              text-transform: uppercase;
              margin: 0;
            }
          }

          .isoDropdownBody {
            width: 100%;
            height: 300px;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;
            background-color: ${palette('grayscale', 6)};

            .isoDropdownListItem {
              padding: 15px 30px;
              flex-shrink: 0;
              text-decoration: none;
              display: flex;
              flex-direction: column;
              text-decoration: none;
              width: 100%;
              ${transition()};

              &:hover {
                background-color: ${palette('grayscale', 3)};
              }

              .isoListHead {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 5px;
              }

              h5 {
                font-size: 13px;
                font-weight: 500;
                color: ${palette('text', 0)};
                margin-top: 0;
              }

              p {
                font-size: 12px;
                font-weight: 400;
                color: ${palette('text', 2)};
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }

              .isoDate {
                font-size: 11px;
                color: ${palette('grayscale', 1)};
                flex-shrink: 0;
              }
            }
          }

          .isoViewAllBtn {
            font-size: 13px;
            font-weight: 500;
            color: ${palette('text', 2)};
            padding: 10px 15px 20px;
            display: flex;
            text-decoration: none;
            align-items: center;
            justify-content: center;
            text-align: center;
            ${transition()};

            &:hover {
              color: ${palette('primary', 0)};
            }
          }

          .isoDropdownFooterLinks {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 30px 20px;

            a {
              font-size: 13px;
              font-weight: 500;
              color: ${palette('text', 0)};
              text-decoration: none;
              padding: 10px 20px;
              line-height: 1;
              border: 1px solid ${palette('border', 1)};
              display: flex;
              align-items: center;
              justify-content: center;
              ${transition()};

              &:hover {
                background-color: ${palette('primary', 0)};
                border-color: ${palette('primary', 0)};
                color: #ffffff;
              }
            }

            h3 {
              font-size: 14px;
              font-weight: 500;
              color: ${palette('text', 0)};
              line-height: 1.3;
            }
          }

          &.withImg {
            .isoDropdownListItem {
              display: flex;
              flex-direction: row;

              .isoImgWrapper {
                width: 35px;
                height: 35px;
                overflow: hidden;
                margin-right: 15px;
                display: -webkit-inline-flex;
                display: -ms-inline-flex;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                background-color: ${palette('grayscale', 9)};
                ${borderRadius('50%')};

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .isoListContent {
                width: 100%;
                display: flex;
                flex-direction: column;

                .isoListHead {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 10px;
                }

                h5 {
                  margin-bottom: 0;
                  padding-right: 15px;
                }

                .isoDate {
                  font-size: 11px;
                  color: ${palette('grayscale', 1)};
                  flex-shrink: 0;
                }

                p {
                  white-space: normal;
                  line-height: 1.5;
                }
              }
            }
          }
        }
      }
    }

    &.topbarMail {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (max-width: 519px) {
              right: -170px;
            }
          }
        }
      }
    }

    &.topbarMessage {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (max-width: 500px) {
              right: -69px;
            }
          }
        }
      }
    }

    &.topbarNotification {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (max-width: 500px) {
              right: -120px;
            }
          }
        }
      }
    }

    &.topbarAddtoCart {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (max-width: 465px) {
              right: -55px;
            }

            .isoDropdownHeader {
              margin-bottom: 0;
            }

            .isoDropdownBody {
              background-color: ${palette('grayscale', 6)};
            }
          }
        }
      }
    }
  }

  .topbar-avatar{
    vertical-align: middle;
    width: 40px;
    height: 40px!important;
    border-radius: 50%;
  }

  .search-bar {
    background: rgba(229, 229, 229, 0.5)!important;
    border-radius: 28px!important;
    border: none!important;
    margin-left: 50%;
  }

  .search-bar .ant-input {
    background: none!important;
    border: none!important;
  }

  .agent-logo{
    position: absolute;
    top: 0px;
    left: 15px;
    z-index: 10000;
    margin-top: 15px;
    @media screen and (max-width: 500px) {
      display: none
    }
  }
`;

export default WithDirection(TopbarWrapper);
